export enum OverKinds {
  // 範囲から外れたら色が変わる
  Color = 0,
  // 範囲内しか入力させない
  Range = 1,
}
